import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Clock, Euro, FileText, TrendingUp } from 'lucide-react';

export const StatsCards = ({
  stats,
  commissionPeriod,
  setCommissionPeriod,
  assignedFilter,
  setAssignedFilter,
  getCommissionForPeriod,
  formatCurrency,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mb-8">
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-600">Totaal Leads</p>
              <p className="text-2xl font-bold text-slate-900" data-testid="total-leads">
                {stats.total_leads || 0}
              </p>
            </div>
            <FileText className="w-8 h-8 text-blue-600" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-600">Nieuwe Leads</p>
              <p className="text-2xl font-bold text-slate-900" data-testid="new-leads">
                {stats.new_leads || 0}
              </p>
            </div>
            <Clock className="w-8 h-8 text-yellow-600" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-600">Klanten</p>
              <p className="text-2xl font-bold text-slate-900" data-testid="converted-leads">
                {stats.converted_leads || 0}
              </p>
            </div>
            <TrendingUp className="w-8 h-8 text-green-600" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-600">Conversie</p>
              <p className="text-2xl font-bold text-slate-900" data-testid="conversion-rate">
                {stats.conversion_rate || 0}%
              </p>
            </div>
            <TrendingUp className="w-8 h-8 text-purple-600" />
          </div>
        </CardContent>
      </Card>

      {/* Commission Card - Compact */}
      <Card className="bg-gradient-to-br from-green-50 to-emerald-50 border-green-200">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center gap-2 mb-1">
                <p className="text-sm text-green-700 font-medium">Commissie</p>
                <Select value={commissionPeriod} onValueChange={setCommissionPeriod}>
                  <SelectTrigger className="h-5 text-xs bg-white border-green-200 w-auto px-2">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="total">Alle tijd</SelectItem>
                    <SelectItem value="month">Maand</SelectItem>
                    <SelectItem value="quarter">Kwartaal</SelectItem>
                  </SelectContent>
                </Select>
                <Select value={assignedFilter} onValueChange={setAssignedFilter}>
                  <SelectTrigger className="h-5 text-xs bg-white border-green-200 w-auto px-2">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Allen</SelectItem>
                    <SelectItem value="wim">Wim</SelectItem>
                    <SelectItem value="jelle">Jelle</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <p className="text-2xl font-bold text-green-800" data-testid="total-commission">
                {formatCurrency(getCommissionForPeriod())}
              </p>
            </div>
            <Euro className="w-8 h-8 text-green-600" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
